import { render, staticRenderFns } from "./Mantenedor_Sectores_Inspeccion.vue?vue&type=template&id=0b77df0b&"
import script from "./Mantenedor_Sectores_Inspeccion.vue?vue&type=script&lang=js&"
export * from "./Mantenedor_Sectores_Inspeccion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports